import styled from '@emotion/styled'

export const Condition = styled.div`
  color: #818080;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 15.73px */
  letter-spacing: 0.133px;
`
